import React, { useEffect, useState, useCallback } from 'react';

import './knowMore.scss';
import { getFromSessionStorage } from '../../../../common/utils/app.utils';
import { MODULE_ID } from '../../../../home/common/constants/constants';
import { PRODUCT_NAME, PRODUCT_TYPE } from '../../../../common/constants/app.constants';
import { formSchema } from '../../choose-plan/formControl';
export const KnowMore = ({ connectivityLineItem: { interfaces, planDetail }, close }) => {
  const getSelectedMedia = useCallback(() => {
    const planSpecs = (planDetail && Array.isArray(planDetail.specs) && planDetail.specs) || [];
    const selectedMedia = planSpecs.length > 0 && planSpecs.find((item) => item.name === 'media');

    return (selectedMedia && selectedMedia.value) || '';
  }, [planDetail]);

  const availableMedia = getSelectedMedia();

  const [productCheck, setProductCheck] = useState(getFromSessionStorage(MODULE_ID, PRODUCT_NAME) === PRODUCT_TYPE.VPN ? PRODUCT_TYPE.VPN : PRODUCT_TYPE.DEDICATED_INTERNET);
  const getSpecsByKeyName = (keyName) => {
    if (Array.isArray(planDetail.specs)) {
      return planDetail.specs.filter((spec) => spec.name === keyName)[0].value || '-';
    }
  };
  const getVpnSpecs = () => {
    const getFormSchema = formSchema && Object.keys(formSchema);
    return (
      planDetail &&
      planDetail.specs &&
      planDetail.specs.length > 0 &&
      planDetail.specs.map((specData, index) => {
        let findIndexSpecs = getFormSchema && getFormSchema.length > 0 && getFormSchema.findIndex((item) => item === specData.name);
        let updatedSpecsName = specData && specData.name.replace(/([A-Z])/g, ' $1');
        let finalSpecsName = updatedSpecsName && updatedSpecsName.charAt(0).toUpperCase() + updatedSpecsName.slice(1);
        if (findIndexSpecs !== -1) {
          return (
            <li>
              <p>
                {finalSpecsName}: {specData.value}{' '}
              </p>
            </li>
          );
        } else {
          return null;
        }
      })
    );
  };
  return (
    <React.Fragment>
      <div className="drawerSection">
        <div className="popup-section cancelOrder">
          <div className="popup_header">
            <h2>Other Details </h2>
            <span className="cross_icon" onClick={close}></span>
          </div>
          <div className="popup_content know-more-popup">
            <p>A few more details of the selected plan are:</p>
            <ol className="details_list" type="1">
              <li>
                <strong>Service Type: {planDetail && planDetail.service}</strong>
                {planDetail && planDetail.service !== 'UNMANAGED' && (
                  <ul className="sub_list">
                    <li>
                      <p>CPE: {planDetail && planDetail.routerSpecs && planDetail.routerSpecs[0].make ? planDetail.routerSpecs[0].make : ''}</p>
                    </li>
                    <li>
                      <p>CPE Specification: {planDetail && planDetail.routerSpecs && planDetail.routerSpecs[0].model ? planDetail.routerSpecs[0].model : ''}</p>
                    </li>
                  </ul>
                )}
              </li>
              <li>
                <strong>Primary Access (Site Level)</strong>
                <ul className="sub_list">
                  <li>
                    <p>Provider: Airtel</p>
                  </li>
                  <li>
                    <p>Interface: {interfaces}</p>
                  </li>
                  <li>
                    <p>Media: {availableMedia || '-'}</p>
                  </li>
                </ul>
              </li>
              {
                <li>
                  <strong>IP Attributes</strong>
                  {productCheck === PRODUCT_TYPE.VPN ? (
                    <ul className="sub_list">{getVpnSpecs()}</ul>
                  ) : (
                    <ul className="sub_list">
                      <li>
                        <p>IP Version: {getSpecsByKeyName('ipVersion')} </p>
                      </li>
                      <li>
                        <p>Routing Type: {getSpecsByKeyName('routingProtocol')}</p>
                      </li>
                      <li>
                        <p>IP Type: {getSpecsByKeyName('ipType')}</p>
                      </li>
                    </ul>
                  )}
                </li>
              }
            </ol>
            {/* <div className="characters">&nbsp;</div> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default KnowMore;
